import React from 'react';
import { Link } from 'react-router-dom';

const ChooseYourPathSection = () => (
  <div className="py-12 bg-white dark:bg-gray-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">
          Your Pathway to Energy Excellence
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
          Follow our proven three-step journey from assessment to ongoing management.
        </p>
      </div>

      <div className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-12 mb-12">
        {/* Step 1: ESA */}
        <div className="relative">
          <div className="bg-emerald-100 dark:bg-emerald-900/30 rounded-3xl p-8 w-64 h-80 flex flex-col items-center justify-center text-center border border-emerald-200 dark:border-emerald-800">
            <div className="bg-emerald-700 dark:bg-emerald-600 rounded-full w-16 h-16 flex items-center justify-center mb-6">
              <span className="text-white text-2xl font-bold">1</span>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">ESA</h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm">(Energy Savings Assessment)</p>
            <p className="text-gray-600 dark:text-gray-400 text-sm mt-2">
              Identifies Opportunities
            </p>
          </div>
          {/* Arrow */}
          <div className="hidden lg:block absolute -right-8 top-1/2 transform -translate-y-1/2">
            <svg
              className="w-6 h-6 text-gray-400 dark:text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>

        {/* Step 2: Energy Management Capability Assessment */}
        <div className="relative">
          <div className="bg-blue-100 dark:bg-blue-900/30 rounded-3xl p-8 w-64 h-80 flex flex-col items-center justify-center text-center border border-blue-200 dark:border-blue-800">
            <div className="bg-blue-700 dark:bg-blue-600 rounded-full w-16 h-16 flex items-center justify-center mb-6">
              <span className="text-white text-2xl font-bold">2</span>
            </div>
            <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-4 leading-tight">
              Energy Management
              <br />
              Capability Assessment
            </h3>

            {/* Two Options */}
            <div className="space-y-3 w-full">
              {/* Online Assessment - Linked to EMHA */}
              <Link to="/emha" className="block">
                <div className="bg-white/70 dark:bg-gray-800/70 rounded-lg px-4 py-3 border border-blue-200 dark:border-blue-700 hover:bg-white/90 dark:hover:bg-gray-700/90 hover:border-blue-300 dark:hover:border-blue-600 transition-colors cursor-pointer">
                  <div className="text-sm font-semibold text-blue-800 dark:text-blue-300">
                    Online Assessment
                  </div>
                  <div className="text-xs text-gray-600 dark:text-gray-400">
                    Annual Energy &lt; $1M
                  </div>
                </div>
              </Link>

              {/* Book a Meeting */}
              <div className="bg-white/70 dark:bg-gray-800/70 rounded-lg px-4 py-3 border border-blue-200 dark:border-blue-700">
                <div className="text-sm font-semibold text-blue-800 dark:text-blue-300">
                  Book a Meeting
                </div>
              </div>
            </div>
          </div>
          {/* Arrow */}
          <div className="hidden lg:block absolute -right-8 top-1/2 transform -translate-y-1/2">
            <svg
              className="w-6 h-6 text-gray-400 dark:text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>

        {/* Step 3: LEAP Programme */}
        <div className="relative">
          <div className="bg-gray-100 dark:bg-gray-800 rounded-3xl p-8 w-64 h-80 flex flex-col items-center justify-center text-center border border-gray-200 dark:border-gray-700">
            <div className="bg-gray-700 dark:bg-gray-600 rounded-full w-16 h-16 flex items-center justifyCenter mb-6">
              <span className="text-white text-2xl font-bold">3</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              LEAP Programme
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm">Ongoing Management</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ChooseYourPathSection;


